import { ref, watch, computed } from '@vue/composition-api'
import { title } from '@core/utils/filter'

// Notification
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import store from '@/store'

export default function useProductsList() {
  // Use toast
  const toast = useToast()

  const refProductListTable = ref(null)

  // Table Handlers
  const tableColumns = [
    {
      key: 'name',
      label: 'Loan Product',
      formatter: title,
      sortable: true,
      // thStyle: {
      //   display: 'none',
      // },
    },
    {
      key: 'description',
      sortable: true,
    },
    {
      key: 'priority',
      label: 'USSD Display Priority',
      sortable: true,
    },
    {
      key: 'status',
      label: 'Is Offered',
      sortable: true,
    },
    {
      key: 'num_inquiries',
      label: 'Total Inquiries',
      sortable: true,
    },
    {
      key: 'actions',
      // thStyle: {
      //   display: 'none',
      // },
    },
  ]
  const perPage = ref(10)
  const totalProducts = ref(0)
  const currentPage = ref(1)
  const perPageOptions = [10, 25, 50, 100]
  const searchQuery = ref('')
  const sortBy = ref('id')
  const isSortDirDesc = ref(true)
  const statusFilter = ref(null)
  const isBusy = ref(false)

  const dataMeta = computed(() => {
    const localItemsCount = refProductListTable.value ? refProductListTable.value.localItems.length : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalProducts.value,
    }
  })

  const refetchData = () => {
    refProductListTable.value.refresh()
  }

  watch([currentPage, perPage, searchQuery, statusFilter], () => {
    refetchData()
  })

  const fetchProducts = (ctx, callback) => {
    isBusy.value = true
    store
      .dispatch('products/fetchProducts', {
        q: searchQuery.value,
        perPage: perPage.value,
        page: currentPage.value,
        sortBy: sortBy.value,
        sortDesc: isSortDirDesc.value,
      })
      .then(response => {
        const { results, pagination } = response.data

        callback(results)
        totalProducts.value = pagination.count
        isBusy.value = false
      })
      .catch(() => {
        toast({
          component: ToastificationContent,
          props: {
            title: "Error fetching products' list",
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  }

  // *===============================================---*
  // *--------- UI ---------------------------------------*
  // *===============================================---*

  const resolveProductStatusVariantAndIcon = status => {
    if (status === 'Not Offered') return { variant: 'secondary', icon: 'XIcon' }
    if (status === 'Offered') return { variant: 'success', icon: 'CheckCircleIcon' }
    if (status === 'Inactive') return { variant: 'danger', icon: 'XIcon' }
    if (status === 'Draft') return { variant: 'primary', icon: 'SaveIcon' }
    if (status === 'Sent') return { variant: 'secondary', icon: 'SendIcon' }
    if (status === 'Past Due') return { variant: 'danger', icon: 'InfoIcon' }
    return { variant: 'secondary', icon: 'XIcon' }
  }
  const resolveProductAvatarVariant = status => {
    if (status === 'Active') return 'primary'
    if (status === 'Paid') return 'danger'
    if (status === 'Inactive') return 'secondary'
    if (status === 'Draft') return 'warning'
    if (status === 'Sent') return 'info'
    if (status === 'Past Due') return 'success'
    return 'primary'
  }

  return {
    fetchProducts,
    tableColumns,
    perPage,
    currentPage,
    totalProducts,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refProductListTable,
    isBusy,

    statusFilter,

    resolveProductStatusVariantAndIcon,
    resolveProductAvatarVariant,
    refetchData,
  }
}
